import React from 'react';
import { TableWithHeader, Notification, STATUS_TYPES } from 'dyl-components';
import TemplateHeader from './TemplatesHeader';
import { Grid, Transition, Segment } from 'semantic-ui-react';
import AddTemplateSectionContainer from './AddTemplateSection';
import ScriptsTable from './TemplatesTable';

import './index.scss';

const Scripts = ({ 
    templates,
    isAddTemplateSectionOpen, 
    onOpenAddTemplateSection,
    onCloseAddTemplateSection,
    onAddTemplate,
    onUpdateTemplate,
    onDelete
}) => (
    <TableWithHeader 
        header={
            <TemplateHeader 
                onOpenAddTemplateSection={onOpenAddTemplateSection} 
            />
        }
        table={
            <React.Fragment>
                <Transition unmountOnHide visible={isAddTemplateSectionOpen} animation='slide down' duration='100'>
                    <Grid>
                        <Grid.Row style={{paddingBottom: 0}}>
                            <Grid.Column className="ScriptsGrid">
                                <Segment basic>
                                    <AddTemplateSectionContainer 
                                        onAddTemplate={onAddTemplate}
                                        onClose={onCloseAddTemplateSection}
                                    />
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Transition>
                {templates.length <= 0 && (
                    <Segment textAlign='center'>
                        <em>There are no templates</em>
                    </Segment>
                )}
                {templates.length > 0 && (
                    <ScriptsTable 
                        templates={templates} 
                        onUpdate={onUpdateTemplate}
                        onDelete={onDelete}
                    />
                )}
            </React.Fragment>
        }
    />
)

class TemplateContainer extends React.Component {
    state = {
        templates: [],
        isAddTemplateSectionOpen: false
    }

    onOpenAddTemplateSelection = () => {
        this.setState({ isAddTemplateSectionOpen: true });
    }

    onCloseAddTemplateSection = () => {
        this.setState({ isAddTemplateSectionOpen: false });
    }

    onUpdateTemplate = (updatedTemplate) => {
        const templates = this.state.templates.slice(0);
        let indexOfTemplateToUpdate = templates.findIndex(template => template.id === updatedTemplate.id);
        if (indexOfTemplateToUpdate !== -1) {
            templates[indexOfTemplateToUpdate] = {...updatedTemplate};
            this.setState({ templates });
        }
    }

    onDelete = (id) => {
        const templates = this.state.templates.slice(0);
        const indexOfTemplateToDelete = templates.findIndex(template => template.id === id);
        if (indexOfTemplateToDelete !== -1) {
            console.log(indexOfTemplateToDelete);
            templates.splice(indexOfTemplateToDelete, 1);
            this.setState({ templates }, () => {
                Notification.alert('Successfully deleted template!', STATUS_TYPES.SUCCESS, true);
            });
        }
    }

    onAddTemplate = (newTemplate) => {
        const templates = this.state.templates.slice(0);
        templates.push(newTemplate);
        this.setState({ templates }, () => {
            Notification.alert('Successfully added template!', STATUS_TYPES.SUCCESS, true);
        });
    }

    render() {
        return (
            <Scripts 
                {...this.state}
                onUpdateTemplate={this.onUpdateTemplate}
                onOpenAddTemplateSection={this.onOpenAddTemplateSelection}
                onCloseAddTemplateSection={this.onCloseAddTemplateSection}
                onAddTemplate={this.onAddTemplate}
                onDelete={this.onDelete}
            />
        )
    }
}

export default TemplateContainer;
